
$(document).ready(function() {

  $('.single-faq').click(function(){
    $(this).toggleClass('active');
  });

  $('#menu-button').click(function(){
    $('#flyout-nav').addClass('active');
  })


  $('#now-playing-feed').eocjsNewsticker({
    speed: 25
  });

   // Smooth scrolling to anchor links
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    var target = $(this.hash);
      if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top
        }, 1000);
      }
  });


  $('#flyout-nav .close').click(function(){
    $('#flyout-nav').removeClass('active');
  });




    //collection slick slider 
  $('.quality-cards').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]  
   });

   //collection slick slider 
  $('.home-featured-coffee-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }     
    ]  
  });
  
 //collection slick slider 
  $('.slick-slider-collections').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }     
    ]  
  });
});